import apiClient from "./apiClient";

export const fetchWorkOrderTemplates = async () => {
  try {
    const response = await apiClient.get("/work-order-templates");
    return response.data;
  } catch (error) {
    console.error("Error fetching work order templates:", error);
    throw new Error("Failed to fetch work order templates. Please try again.");
  }
};

export const createWorkOrderTemplate = async (templateData) => {
  try {
    const response = await apiClient.post("/work-order-templates", templateData);
    return response.data;
  } catch (error) {
    console.error("Error creating work order template:", error);
    throw new Error("Failed to create work order template. Please try again.");
  }
};

export const updateWorkOrderTemplate = async (templateId, templateData) => {
  try {
    const response = await apiClient.put(`/work-order-templates/${templateId}`, templateData);
    return response.data;
  } catch (error) {
    console.error("Error updating work order template:", error);
    throw new Error("Failed to update work order template. Please try again.");
  }
};

export const deleteWorkOrderTemplate = async (templateId) => {
  try {
    const response = await apiClient.delete(`/work-order-templates/${templateId}`);
    return response.data || { message: "Work order template deleted successfully" };
  } catch (error) {
    console.error("Error deleting work order template:", error);
    throw new Error("Failed to delete work order template. Please try again.");
  }
};

export const createWorkOrderTask = async (templateId, taskData) => {
  try {
    const response = await apiClient.post(`/work-order-tasks/${templateId}/tasks`, taskData);
    return response.data;
  } catch (error) {
    console.error("Error creating work order task:", error);
    throw new Error("Failed to create work order task. Please try again.");
  }
};

export const updateWorkOrderTask = async (templateId, taskId, taskData) => {
  try {
    const response = await apiClient.put(`/work-order-templates/${templateId}/tasks/${taskId}`, taskData);
    return response.data;
  } catch (error) {
    console.error("Error updating work order task:", error);
    throw new Error("Failed to update work order task. Please try again.");
  }
};

export const deleteWorkOrderTask = async (templateId, taskId) => {
  try {
    const response = await apiClient.delete(`/work-order-templates/${templateId}/tasks/${taskId}`);
    return response.data || { message: "Work order task deleted successfully" };
  } catch (error) {
    console.error("Error deleting work order task:", error);
    throw new Error("Failed to delete work order task. Please try again.");
  }
};

export const reorderWorkOrderTasks = async (templateId, reorderedTasks) => {
  try {
    const response = await apiClient.put(`/work-order-templates/${templateId}/tasks/reorder`, {
      tasks: reorderedTasks,
    });
    return response.data;
  } catch (error) {
    console.error("Error reordering work order tasks:", error);
    throw new Error("Failed to reorder work order tasks. Please try again.");
  }
};